import { render } from "./WelcomeImg.vue?vue&type=template&id=988b6cfe"
import script from "./WelcomeImg.vue?vue&type=script&lang=js"
export * from "./WelcomeImg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__